import { Form as AntForm } from "antd";
import type { FormProps as AntFormProps } from "antd";

interface FormProps extends AntFormProps {
  children: React.ReactNode;
}

export function Form({ children, ...props }: FormProps) {
  return <AntForm {...props}>{children}</AntForm>;
}

// Re-exportar componentes útiles de Form
export const FormItem = AntForm.Item;
export const useForm = AntForm.useForm;
